import { useDnD } from '../../context/DnDContext';
import IconRenderer from '../../features/diagram/ui/nodes/node.icon';
import { shapeMap } from '../../features/diagram/ui/nodes/shape/shape.map';
import { ShapeTypes } from '@diagram/model/node.model';
const NodePalette = () => {
  const dndContext = useDnD();
  if (!dndContext) {
    throw new Error('useDnD must be used within a DnDProvider');
  }
  const { setData } = dndContext;
  const onDragStart = (event: React.DragEvent, shapeType: ShapeTypes) => {
    event.dataTransfer.effectAllowed = 'move';
    setData({
      type: 'shape',
      shape: shapeType,
      width: shapeMap[shapeType].width,
      height: shapeMap[shapeType].height,
    });
  };

  return (
    <div className="node-palette grid grid-cols-3 grid-rows-2 gap-3">
      {Object.entries(shapeMap).map(([shapeType, config]) => (
        <div
          key={shapeType}
          className="p-1 stroke-gray-600 stroke-4 flex justify-center items-center hover:stroke-accent cursor-pointer rounded-md bg-white border border-gray-200 shadow-sm hover:shadow-md transition-all duration-200 ease-in-out"
          draggable
          onDragStart={(event) => {
            onDragStart(event, shapeType as ShapeTypes);
          }}
        >
          <IconRenderer
            render={config.render}
            shapeWidth={config.width}
            shapeHeight={config.height}
            height={30}
          />
          <span className="sr-only">{shapeType}</span>
        </div>
      ))}
      {/* Add more draggable nodes here */}
    </div>
  );
};

export default NodePalette;
